import type { VoidFunctionComponent } from 'react';
import TextInput from '../../generic/Forms/TextInput';

type LabelTextInputProps = {
  value: string;
  onChange: (value: string) => void;
  inputValidationRegex?: RegExp;
  onValidationChange?: (isValid: boolean) => void;
};

export const LabelTextInput: VoidFunctionComponent<LabelTextInputProps> = ({
  value,
  onChange,
  inputValidationRegex,
  onValidationChange,
}) => {
  const maxSize = 50;

  const handleChange = (newValue: string) => {
    onChange(newValue);

    if (inputValidationRegex && onValidationChange) {
      onValidationChange(inputValidationRegex.test(newValue));
    }
  };

  return (
    <TextInput
      size="small"
      value={value}
      label="change label value"
      placeholder="Enter a unique label..."
      maxLength={maxSize}
      suffix={`${value.length}/${maxSize}`}
      onChange={handleChange}
    />
  );
};
